import React, { useState } from 'react'
import Input from '../Input/Input'
import * as S from './Filter.styled'
import CheckBox from '../CheckBox/CheckBox'
import { Store } from 'effector'
import { useList } from 'effector-react'
export interface IDesktopFilterProps {
    useCheckSelected: (id: string) => boolean
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    useToggleSelected: () => any
    title: string
    filterStore: Store<string[]>
    useLength: () => number
}

interface IGoodFilterSelectedProps {
    id: string
    useCheckSelected: (id: string) => boolean
    toggleSelected: (id: string) => void
}

const FilterItem = ({ id, toggleSelected, useCheckSelected }: IGoodFilterSelectedProps) => {
    const isSelected = useCheckSelected(id)
    return (
        <CheckBox key={id} clickHandler={() => toggleSelected(id)} checked={isSelected}>
            {id}
        </CheckBox>
    )
}

const DesktopFilter = ({ title, useLength, useToggleSelected, filterStore, useCheckSelected }: IDesktopFilterProps) => {
    const [searchText, setSearchText] = useState('')
    const length = useLength()
    const toggleSelected = useToggleSelected()

    const filterList = useList(filterStore, (filter) => (
        <FilterItem key={filter} id={filter} toggleSelected={toggleSelected} useCheckSelected={useCheckSelected} />
    ))

    if (length <= 0) return <React.Fragment />

    const changeSearchText = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value)
    }

    return (
        <S.Container>
            <S.Title>{title}</S.Title>
            {length > 7 && <Input value={searchText} onChange={changeSearchText} type="search" />}
            <S.FilterList>{filterList}</S.FilterList>
        </S.Container>
    )
}

export default DesktopFilter
